(() => {
	angular
		.module('main')
		.controller('PaymentsOverviewController', PaymentsOverviewController);

	PaymentsOverviewController.$inject = [
		'$scope',
		'$rootScope',
		'jobDataService',
		'timeService',
		'messageService',
		'validationService',
		'emailService',
		'invoicesDataService',
		'templateRequestsService',
		'fileUploadService'
	];

	function PaymentsOverviewController(
		$scope,
		$rootScope,
		jobDataService,
		timeService,
		messageService,
		validationService,
		emailService,
		invoicesDataService,
		templateRequestsService,
		fileUploadService
	) {
		clearAttachments();

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		// Email methods
		$scope.retrySendMail = function() {
			emailService.callLastEmailFn();
		};

		$scope.showSendPaymentReceipt = function(payment) {
			$scope.paymentReceiptId = payment.id;
			delete $scope.sendMessage;
			$scope.sendMessage = { emailTo: payment.email };

			templateRequestsService.getTemplates('all').subscribe(
				data => {
					if (data) {
						$scope.emails = data;
						if ($scope.emails) {
							$scope.choosenEmail =
								$scope.emails.find(
									item =>
										item.emailTemplateType ===
										'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE'
								) || {};
						}
						$('#sendInvoiceModal')
							.modal('show')
							.on('shown.bs.modal', function() {
								const input = $(this).find('input');
								const select = $(this).find('select');

								validationService.isModalClosePrevented(input);
								validationService.isModalClosePrevented(select);
							});
					}
				},
				err => messageService.showDefaultErrorMessage(err)
			);
		};

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		$scope.setEmail = function(site) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);
			$scope.sendMessage.emailCc = stringEmail;
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		$scope.sendPaymentReceipt = function() {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			$scope.disableBtnOnSend = true;
			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);

			const obj2save = angular.copy($scope.sendMessage);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			const storedFiles = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const uploadedFiles = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			const dataToSend = {
				sendMessageData: $scope.sendMessage,
				storedFiles,
				uploadedFiles
			};

			invoicesDataService
				.sendInvoiceEmail(dataToSend, 'receipt', $scope.paymentReceiptId)
				.finally(() => ($scope.disableBtnOnSend = false))
				.subscribe(
					data => successSendReceipt(data),
					err => errorSendReceipt(err)
				);

			function successSendReceipt(data) {
				$('#sendInvoiceModal').modal('hide');
				$scope.showCcField = false;

				$scope.$evalAsync();

				for (const prop in $scope.sendMessage) {
					$scope.sendMessage[prop] = '';
				}

				if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
					if ($scope.attachmentsData.attachments.length) {
						$scope.attachmentsData.attachments.length = 0;
					}
				}
				messageService.showToaster('s_11', 'payments');
			}

			function errorSendReceipt({ status, data }) {
				$scope.disableBtnOnSend = false;
				const errorMessage = data.errorMessage;
				let errorCode, errorPlace, value;

				if (status >= 400 && status < 500 && errorMessage) {
					if (errorMessage === 'Email text should contain an invoice link') {
						errorCode = 'e_7';
						errorPlace = 'editInvoice';
					} else {
						errorCode = 'e_2';
						errorPlace = 'general';
						value = errorMessage;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}
		};

		let clientsEmailTimer;
		$scope.clientEmails = [];
		$scope.$watchCollection('sendMessage', newValue => {
			if (newValue) {
				if (!newValue.emailCc) {
					$scope.sendMessage.emailCc =
						angular.element('#sendInvoiceMessageData_emailCc').val() || '';
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		function emailSearchRequest(search) {
			jobDataService
				.searchClient(search)
				.then(result => findClientSuccessCallback(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue !== null) {
				templateRequestsService
					.getTemplates('full_template', newValue.id)
					.subscribe(data => successGetEmail(data));
			}
		});

		function successGetEmail(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text;
				$scope.sendMessage.emailCc = '';

				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(
							email.storedAttachments
						)
					};
				} else {
					clearAttachments();
				}
			}
		}

		$scope.disableDragDrop = function() {
			return true;
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/paymentsOverviewController.js